// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recommendation-background[data-v-8e6f6d0a]{background-color:#ffff90}.recommendation-alert[data-v-8e6f6d0a]{color:#ff1709;font-size:12px}.recommendation-link[data-v-8e6f6d0a]{color:#00f;font-weight:700}", ""]);
// Exports
module.exports = exports;
